export enum DoorSize {
    Indeterminate = 0,
    Custom = 1,
    Storm_30x74 = 2,
    Storm_30x76 = 3,
    Storm_30x78 = 4,
    Storm_30x81 = 5,
    Storm_32x74 = 6,
    Storm_32x75 = 7,
    Storm_32x76 = 8,
    Storm_32x78 = 9,
    Storm_32x81 = 10,
    Storm_32x96 = 11,
    Storm_34x78 = 12,
    Storm_34x81 = 13,
    Storm_36x74 = 14,
    Storm_36x78 = 15,
    Storm_36x81 = 16,
    Storm_36x96 = 17,
}

